import React from "react";
import { any, bool, func, object, string } from "prop-types";
import GenericStep from "./GenericStep";
import TagsInput from "./TagsInput";
import useStepTags from "./useStepTags";

function InstagramStep({
  form,
  onFormDisabled,
  contractName,
  visible,
  campaignSteps,
  companyName,
  platform,
  link,
  emailTemplates,
  addEmailTemplate,
}) {
  const {
    tags: instaTags,
    setTags: setInstaTags,
    tagsInputComponent,
    formPreSubmit,
    setExistingStep,
    formReset,
  } = useStepTags("instaTags");

  const handleFormDisabled = disabled => {
    formReset(!disabled, onFormDisabled);
  };

  return (
    <GenericStep
      form={form}
      onFormDisabled={handleFormDisabled}
      stepType="instagram"
      contractName={contractName}
      onExistingFieldSelect={setExistingStep}
      invisibleFormFields={["instaTags"]}
      formPreSubmit={formPreSubmit}
      visible={visible}
      campaignSteps={campaignSteps}
      companyName={companyName}
      platform={platform}
      link={link}
      emailTemplates={emailTemplates}
      addEmailTemplate={addEmailTemplate}
    >
      <TagsInput
        ref={tagsInputComponent}
        label="Add Instagram Tags"
        tags={instaTags}
        setTags={setInstaTags}
      />
    </GenericStep>
  );
}

InstagramStep.propTypes = {
  form: any,
  onFormDisabled: func,
  contractName: string,
  visible: bool,
  campaignSteps: object,
  companyName: string,
  platform: string,
  link: string,
  emailTemplates: object,
  addEmailTemplate: func,
};

export default InstagramStep;
